import { Component, inject } from '@angular/core';
import { RouterOutlet } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';

@Component({
  selector: 'app-root',
  standalone: true,
  imports: [RouterOutlet],
  templateUrl: './app.component.html',
  styleUrls: ['./app.component.scss'],
})
export class AppComponent {
  private translate = inject(TranslateService);

  isToggled = false;

  constructor(
  ) {    
    this.translate.use('es'); // Usar español al iniciar

  }

  changeLanguage(lang: string) {
    this.translate.use(lang);
  }

}
